/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Highlight_Settings_Line_BackgroundInputs */

const en_highlight_settings_line_background = /** @type {(inputs: Highlight_Settings_Line_BackgroundInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Line background`)
};

const es_highlight_settings_line_background = /** @type {(inputs: Highlight_Settings_Line_BackgroundInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Fondo de línea`)
};

/**
* | output |
* | --- |
* | "Line background" |
*
* @param {Highlight_Settings_Line_BackgroundInputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const highlight_settings_line_background = /** @type {((inputs?: Highlight_Settings_Line_BackgroundInputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Highlight_Settings_Line_BackgroundInputs, { locale?: "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_highlight_settings_line_background(inputs)
	return en_highlight_settings_line_background(inputs)
});